export const desktopAppLaunchUrl = 'superseeded-studio://open'

type DesktopLaunchFallbackOptions = {
  fallbackDelayMs?: number
}

export function openDesktopAppWithFallback (
  fallbackUrl: string,
  options: DesktopLaunchFallbackOptions = {}
) {
  if (typeof window === 'undefined' || typeof document === 'undefined') {
    return
  }

  const fallbackDelayMs = options.fallbackDelayMs ?? 1200
  let pageLikelyLeft = false

  const markLikelyLeft = () => {
    pageLikelyLeft = true
  }
  const handleVisibilityChange = () => {
    if (document.visibilityState !== 'visible') {
      markLikelyLeft()
    }
  }
  const cleanup = () => {
    window.removeEventListener('blur', markLikelyLeft)
    window.removeEventListener('pagehide', markLikelyLeft)
    document.removeEventListener('visibilitychange', handleVisibilityChange)
  }

  window.addEventListener('blur', markLikelyLeft, { once: true })
  window.addEventListener('pagehide', markLikelyLeft, { once: true })
  document.addEventListener('visibilitychange', handleVisibilityChange)

  try {
    window.location.href = desktopAppLaunchUrl
  } catch {
    cleanup()
    window.location.assign(fallbackUrl)
    return
  }

  window.setTimeout(() => {
    cleanup()
    if (!pageLikelyLeft && document.visibilityState === 'visible') {
      window.location.assign(fallbackUrl)
    }
  }, fallbackDelayMs)
}
